import React, { Fragment, useEffect, useState, useContext } from "react";
import styled, { css } from "styled-components";
import { Context } from "../context";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { Route, Redirect } from "react-router";
import './gs.css';
import './gs_add.css';
import { Layout } from './Layout';
import { dateFormat } from './utils';
import { Projects } from './Projects';
import { Scrubber } from './Scrubber';


export function Routes(props) {

  const context = useContext(Context);

  return (
    <>
      {/* <Elements stripe={stripePromise}> */}
      <Router
        // history={hist}
        >
          <Switch>
            <Route
              exact
              path="/clear"
              render={({ history }) => {
                localStorage.clear();
                history.push("");
                return null;
              }}
            />


            <Route
              exact path="/calendar/today"
              render={(props) => {
                return(
                <>
                  {/* <Redirect to={`/calendar/${dateFormat}`} /> */}
                  <Redirect to={`/rectaB86cduR12OJp`} />
                </>
              )}}
            />

            <Route
              path="/calendar/:year?/:month?/:day?"
              render={(props) => {
                return(
                  <Layout/>
              )}}
            />


            <Route
              path="/list/:playlistId?/:videoId?"
              render={({match}) => {
                return(
                  <Layout playlistId={context.handles.getPlaylistIdFromName(match.params['playlistId'])} videoId={match.params['videoId']}/>
              )}}
            />

            <Route
              path="/list/:playlistId?"
              render={({match}) => {
                return(
                  <Layout playlistId={context.handles.getPlaylistIdFromName(match.params['playlistId'])} />
              )}}
            />


            <Route
              path="/projects"
              render={({match}) => {
                return(
                  <Projects />
              )}}
            />

            <Route
              path="/videoscrubber"
              render={({match}) => {
                return(
                  <Scrubber />
              )}}
            />

            <Route
              exact path="/"
              render={(props) =>
                {
                  return(
                <>
                  <Redirect to="/list/rectaB86cduR12OJp" />
                </>
              )}}
            />
          </Switch>
        </Router>

        {/* <Checkout/> */}
      {/* </Elements> */}
    </>
  );
}
